import { Pipe, PipeTransform } from "@angular/core";


/**
 * Displays phone in (###) ###-#### format
 * 
 * @export
 * @class PhonePipe
 * 
 * Usage:
 *   value | phone
 * Example:
 *   {{5555555555 | phone}}
 *   formats to: (555) 555-5555
 * 
 */
@Pipe({
    name: "phone"
})
export class PhonePipe implements PipeTransform
{
    /**
     * Transforms a 10 digit number to a phone number format
     * @param {string} phone phone number to format
     * @returns a phone number with the format (###) ###-####
     */
    public transform(phone: string): string | null
    {
        if (phone)
        {
            return phone.toString().replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
        }

        return null;
    }
}
